import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfile.scss'
import { Row, Col } from 'react-bootstrap'
import PendingApprovalWorkExperienceEditor from './PendingApprovalAdviserProfileWorkExperienceEditor/PendingApprovalAdviserProfileWorkExperienceEditor'
import PendingApprovalAdviserProfileBlurbEditor from './PendingApprovalAdviserProfileBlurbEditor/PendingApprovalAdviserProfileBlurbEditor'
import PendingApprovalAdviserProfileEducationEditor from './PendingApprovalAdviserProfileEducationEditor'
import AdviserProfileInvestmentMinimumsEditor from './AdviserProfileInvestmentMinimumsEditor/AdviserProfileInvestmentMinimumsEditor'
import AdviserProfileLanguagePreferencesEditor from './AdviserProfileLanguagePreferencesEditor/AdviserProfileLanguagePreferencesEditor'
import AdviserProfileAreasOfSpecialisationEditor from './AdviserProfileAreasOfSpecialisationEditor/AdviserProfileAreasOfSpecialisationEditor'
import AdviserProfileClientTypesEditor from './AdviserProfileClientTypesEditor/AdviserProfileClientTypesEditor'
import AdviserProfilePromoteToApproved from './AdviserProfilePromoteToApproved/AdviserProfilePromoteToApproved'
import PendingApprovalAdviserProfileConflictDeclarationsEditor from './PendingApprovalAdviserProfileConflictDeclarationsEditor/PendingApprovalAdviserProfileConflictDeclarationsEditor'
import AdviserProfilePicturesEditor from './AdviserProfilePicturesEditor'
import PendingApprovalAdviserProfileContactDetailsEditor from './PendingApprovalAdviserProfileContactDetailsEditor/PendingApprovalAdviserProfileContactDetailsEditor'
import Spinner from '../../../../common/Spinners/Spinner'
import RejectPendingApprovalProfile from '../AdviserProfile/RejectPendingApprovalProfile'
import EditButton from '../../../../common/forms/EditButton'
import EditProfileButton from '../../../../common/forms/EditProfileButton'
import PropTypes from 'prop-types';

class AdviserProfile extends React.Component {
  static propTypes = {
    pendingApprovalProfile: PropTypes.object.isRequired,
    publishedProfile: PropTypes.object.isRequired,
    cancelEditingProfile: PropTypes.func.isRequired,
    submitProfile: PropTypes.func.isRequired,
    submittingProfile: PropTypes.bool.isRequired,
    submittedProfile: PropTypes.bool.isRequired,
    editingProfile: PropTypes.bool.isRequired,
    editProfile: PropTypes.func.isRequired,
    stopEditingProfile: PropTypes.func.isRequired,
    containerIsValid: PropTypes.bool.isRequired,
    edited: PropTypes.bool.isRequired
  };

  render () {
    const { pendingApprovalProfile, publishedProfile } = this.props
    const profile = pendingApprovalProfile
    if (!profile || (profile && !profile.adviserId)) {
      return <Spinner />
    }
    return (
      <Row>
        <Col sm={4} md={3} lg={3} className="d-none d-sm-block">
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfilePicturesEditor
                profile={profile}
                profilePicture={profile.profilePic}
                companyLogo={profile.companyLogo}
              />
            </Col>
          </Row>
          {this.props.editingProfile && (
            <Row>
              <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
                <PendingApprovalAdviserProfileContactDetailsEditor
                  pendingApprovalProfile={profile}
                  publishedProfile={publishedProfile}
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfileAreasOfSpecialisationEditor profile={profile} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfileLanguagePreferencesEditor profile={profile} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfileClientTypesEditor profile={profile} />
            </Col>
          </Row>
        </Col>
        <Col sm={8} md={9} lg={9} className="d-none d-sm-block">
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <PendingApprovalAdviserProfileBlurbEditor
                pendingApprovalProfile={profile}
                publishedProfile={publishedProfile}
              >
                <EditProfileButton
                  buttonText={'Edit'}
                  size={'lg'}
                  onClick={this.props.editProfile}
                  isDisabled={false} />
              </PendingApprovalAdviserProfileBlurbEditor>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfileInvestmentMinimumsEditor
                oldProfile={publishedProfile}
                profile={profile}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <PendingApprovalAdviserProfileEducationEditor
                pendingApprovalProfile={profile}
                publishedProfile={publishedProfile}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <PendingApprovalWorkExperienceEditor
                pendingApprovalProfile={profile}
                publishedProfile={publishedProfile}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <PendingApprovalAdviserProfileConflictDeclarationsEditor
                oldProfile={this.props.pendingApprovalProfile}
                profile={profile}
              />
            </Col>
          </Row>
          {!this.props.editingProfile && (
            <Row className={styles['row-top-padding']}>
              <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
                <AdviserProfilePromoteToApproved
                  profile={profile}
                  isSubmitting={this.props.submittingProfile}
                  rejectButton={<RejectPendingApprovalProfile profile={profile} isSubmitting={this.props.submittingProfile} />}
                />
                {this.props.submittedProfile}
              </Col>
            </Row>
          )}
          {this.props.editingProfile && (
            <Col sm={12} md={12} lg={12}>
              <EditButton
                stopEditing={() => {
                  this.props.stopEditingProfile()
                  this.props.submitProfile(this.props.pendingApprovalProfile)
                }}
                formIsValid={this.props.edited}
                submitting={this.props.submittingProfile}
                cancelEditing={this.props.cancelEditingProfile}
                editing
              />
            </Col>
          )}
        </Col>
      </Row>
    )
  }
}

export default  (AdviserProfile)
